import { NgModule } from 'ng-metadata/core';
import {ControlledVocabulary} from './controlledVocabulary.directive';
import {ControlledVocabularyService} from './controlledVocabulary.service';

@NgModule({
    declarations: [ControlledVocabulary],
    providers: [
        ControlledVocabularyService
    ],
    imports:[

    ]
})
export class ControlledVocabularyModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/controlledVocabulary/controlledVocabulary.module.ts